import React, { useEffect, useState } from 'react';
import TrackingIDForm from './TrackingID.Form';
import CancelOrderForm from './CancelOrder.Form';
import ImageModal from './ImageModal';
import ReturnRejectForm from './ReturnReject.Form';
import RejectReason from './RejectReason';
import { useSelector } from 'react-redux';
import ExchangeRejectForm from './ExchangeReject.Form';
import PickupConfirmation from './PickupConfirmation';

function Modal({ reasonToReject, updateRejectReason, updateExchangeRejectReason, handleCancel, rejectReturn,rejectExchange }) {
    const activeModal = useSelector((state) => state.orderDetails.activeModal);
    const modalDisplay = useSelector((state) => state.orderDetails.modalDisplay);

    const [visible, setVisible] = useState(false);

    useEffect(() => {
        if(modalDisplay) {
            setVisible(true);
        }
        else {
            setVisible(false);
        }
    }, [modalDisplay]);

    return (
        <div className={`${visible ? 'opacity-100 visible bg-[#00000080]' : 'opacity-0 invisible'} transition-all duration-100 ease-in-out fixed z-50 size-full top-0 left-0 flex justify-center items-center`}>
            {activeModal === 'tracking' && <TrackingIDForm />}

            {activeModal === 'cancel-order' && 
                <CancelOrderForm 
                    handleCancel={handleCancel}
                />
            }

            {activeModal === 'pickup-confirm' && <PickupConfirmation />}

            {activeModal === 'image' && <ImageModal />}

            {activeModal === 'return-reject' && 
                <ReturnRejectForm 
                    rejectReturn={rejectReturn} 
                    updateRejectReason={val => updateRejectReason(val)} 
                />
            }

            {activeModal === 'exchange-reject' && 
                <ExchangeRejectForm 
                    rejectExchange={rejectExchange} 
                    updateExchangeRejectReason={val => updateExchangeRejectReason(val)} 
                />
            }

            {activeModal === 'reject-reason' && 
                <RejectReason 
                    rejectReason={reasonToReject}
                />
            }
        </div>
    );
}

export default Modal;
